import * as React from 'react';
import { useFiltersContext } from '../../contexts/filters';
import { useSettingsContext } from '../../contexts/settings';

const Search = () => {
	const { searchQuery, setSearchQuery } = useFiltersContext();
	const [value, setValue] = React.useState(searchQuery);
	const settings = useSettingsContext();
	React.useEffect(() => {
		const delayDebounceFn = setTimeout(() => {
			setSearchQuery(value);
		}, 600);

		return () => clearTimeout(delayDebounceFn);
	}, [value]);

	React.useEffect(() => {
		if (!searchQuery.length) {
			setValue('');
		}
	}, [searchQuery]);

	const searchParentRef = React.useRef(false);
	const handleOnFocus = () => {
		searchParentRef.current.classList.add('pfa-search--focus');
	};

	const handleOnBlur = () => {
		searchParentRef.current.classList.remove('pfa-search--focus');
	};

	return (
		<div className="pfa-search">
			<div className="pfa-filters-bar__title">{settings.searchTitle}</div>
			<div className="pfa-search__wrapper" ref={searchParentRef}>
				<input
					className="pfa-search__input"
					type="text"
					value={value}
					onChange={(e) => setValue(e.target.value)}
					placeholder="Search"
					onFocus={() => handleOnFocus()}
					onBlur={() => handleOnBlur()}
				/>

				<button className="pfa-search__icon" onClick={() => setValue('')}>
					{!!value.length ? (
						<svg
							xmlns="http://www.w3.org/2000/svg"
							width="18"
							height="18"
							viewBox="0 0 18 18"
							fill="none"
						>
							<path
								fillRule="evenodd"
								clipRule="evenodd"
								d="M16.702 2.67139C17.2097 2.16371 17.2097 1.34059 16.702 0.83291C16.1944 0.325228 15.3713 0.325228 14.8636 0.832909L8.53489 7.1616L2.27686 0.903565C1.76917 0.395883 0.94606 0.395884 0.438378 0.903565C-0.069303 1.41125 -0.0693035 2.23436 0.438378 2.74204L6.69641 9.00007L0.438593 15.2579C-0.069088 15.7656 -0.0690876 16.5887 0.438594 17.0964C0.946275 17.604 1.76939 17.604 2.27707 17.0964L8.53489 10.8386L14.8634 17.167C15.371 17.6747 16.1942 17.6747 16.7018 17.167C17.2095 16.6593 17.2095 15.8362 16.7018 15.3285L10.3734 9.00007L16.702 2.67139Z"
								fill="#474747"
							/>
						</svg>
					) : (
						<svg
							xmlns="http://www.w3.org/2000/svg"
							width="21"
							height="22"
							viewBox="0 0 21 22"
							fill="none"
						>
							<path
								fillRule="evenodd"
								clipRule="evenodd"
								d="M16.1945 15.4634L20.1157 19.3847L20.1158 19.3846C20.6253 19.8942 20.6253 20.7138 20.0936 21.2234C19.8499 21.4671 19.5176 21.6 19.1853 21.6C18.853 21.6 18.5206 21.4671 18.277 21.2234L14.2007 17.1471C12.7828 18.0333 11.0991 18.565 9.28249 18.565C4.16493 18.565 0 14.4 0 9.28249C0 4.16493 4.16493 0 9.28249 0C14.4 0 18.565 4.16493 18.565 9.28249C18.565 11.653 17.6566 13.824 16.1945 15.4634ZM9.28423 2.5918C5.58453 2.5918 2.59375 5.60473 2.59375 9.28228C2.59375 12.982 5.60668 15.9728 9.28423 15.9728C12.9618 15.9728 15.9526 12.9598 15.9526 9.28228C15.9526 5.60473 12.9839 2.5918 9.28423 2.5918Z"
								fill="#8B8B8B"
							/>
						</svg>
					)}
				</button>
			</div>
		</div>
	);
};

Search.displayName = 'Search';

export default Search;
